import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useSpring, animated } from "react-spring";

const ToggleButton: React.FC<{isOn?: boolean, setIsOn?: Dispatch<SetStateAction<boolean>>}> = ({ isOn, setIsOn }) => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (isOn) {
      setIsActive(isOn);
    }
    else {
      setIsActive(false);
    }
  }, [isOn])

  const handleToggle = () => {
    setIsActive(!isActive);
    if (setIsOn) {
      setIsOn(isActive)
    }
  };

  const circleSpringProps = useSpring({
    left: isActive ? '22px' : '2px',
  });

  return (
    <div className="w-10 h-5 relative flex items-center justify-center cursor-pointer" onClick={handleToggle}>
      <div className={`absolute inset-0 ${isActive ? "bg-gradient-to-r from-[#8C84FF] to-[#6158E0]" : "bg-[#e0e0e0]"} rounded-full`} />
      <animated.div
        className="w-4 h-4 absolute bg-white rounded-full shadow"
        style={{
          ...circleSpringProps,
          cursor: 'pointer',
          top: '50%',
          transform: 'translateY(-50%)',
        }}
      />
    </div>
  );
};

export default ToggleButton;
